import {IconCheck, IconCross, IconInfoCircle} from '../../icon';
import {Flex, Box} from '../../layout';
import Paper from './Paper';
import Portal from './Portal';
import React, {useLayoutEffect, useState} from 'react';
import {Transition} from 'react-transition-group';

type ToastType = 'success' | 'error' | 'info';
type Props = {
    type: ToastType;
    children: React.ReactNode;
    onRequestClose: () => void;
    timer: number;
};

const transitionStyles = {
    entering: '0',
    entered: '0',
    exiting: '-4rem',
    exited: '-4rem'
};

function getIcon(type: ToastType) {
    switch (type) {
        case 'success':
        default:
            return IconCheck;
        case 'error':
            return IconCross;
        case 'info':
            return IconInfoCircle;
    }
}

function getColor(type: ToastType) {
    switch (type) {
        case 'success':
            return 'green';
        case 'error':
            return 'red';
        case 'info':
            return 'blue';
        default:
            break;
    }
}
export default function Toast({type, onRequestClose, children, timer}: Props) {
    const Icon = getIcon(type);
    const [inProp, setIn] = useState(false);

    useLayoutEffect(() => {
        let toastExitDelay = timer;
        if ('Cypress' in window) toastExitDelay = 150;
        const enter = setTimeout(() => setIn(true), 10);
        const delay = setTimeout(() => setIn(false), toastExitDelay);
        return () => {
            clearTimeout(enter);
            clearTimeout(delay);
        };
    }, []);

    // Portal to document.body — Overlay modals portal there too, so in-tree toasts sit behind them.
    return (
        <Portal zIndex="Toast">
            <Transition in={inProp} timeout={500} onExited={onRequestClose}>
                {(state) => (
                    <Flex
                        left="50%"
                        style={{
                            transform: `translateX(-50%) translateY(${transitionStyles[state]})`,
                            transition: 'transform 160ms'
                        }}
                        justifyContent="center"
                        top=".75rem"
                        position="fixed"
                    >
                        <Paper
                            backgroundColor={getColor(type)}
                            color="white"
                            round
                            px={3}
                            py={2}
                            fontWeight="bold"
                        >
                            <Flex alignItems="center">
                                <Icon size="1.5rem" color="white" />
                                <Box ml={3}>{children}</Box>
                            </Flex>
                        </Paper>
                    </Flex>
                )}
            </Transition>
        </Portal>
    );
}
